/**
 * @file The ONE reading of a derive stamp's State column (spec §11): a skip maps
 * to its fixed filler-safe reason, a stamp at the configuration revision is up to
 * date, and anything else — a stamp behind the revision, or no stamp at all — is
 * waiting to recalculate. Consumers: `FormDeriveHealthPanel` (the pane's per-derive
 * rows, off the sampled stamp `formDeriveStatus` returns) and
 * `FormDerivedValuesPanel` (the per-form drawer, off this version's own stamp).
 * Invariants: the raw skip enum never reaches a screen; an absent stamp is
 * "waiting", never "up to date" and never a claim that a value is being computed —
 * nothing at this level can observe a computation in flight.
 */
import type { FormDeriveSkipReason } from '#types';
import { formDeriveCopy } from './formDeriveCopy';

/** A `FormDeriveStamp` or the wire row that carries the same two facts. */
export type FormDeriveStateStamp = {
  skipped?: FormDeriveSkipReason | null;
  rev?: number | null;
};

function formDeriveStateLabel(
  stamp: FormDeriveStateStamp | undefined,
  configRev: number,
): string {
  const skipped = stamp?.skipped;
  if (skipped !== undefined && skipped !== null) return formDeriveCopy.skipReason[skipped];
  return stamp?.rev === configRev ? formDeriveCopy.upToDate : formDeriveCopy.waitingToRecalculate;
}

export { formDeriveStateLabel };
